module.exports = __webpack_public_path__ + "static/together-1125b53e5932f1eaafbd9c802fa41b01.svg";